module.exports = __webpack_public_path__ + "img/upgrade.606383bc.png";